import React, { useEffect } from 'react';
import OrderHistory from '../components/OrderHistory';
import { usePayment } from '../contexts/PaymentContext';
import AIChatButton from '../components/AIChatButton';

const MyOrders: React.FC = () => {
  const { getUserOrders, isLoading, orders } = usePayment();

  useEffect(() => {
    // Ensure latest orders are loaded when visiting the page
    getUserOrders();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="p-4 sm:p-6 lg:p-8">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">My Orders</h1>
        <p className="text-gray-600">View and track your purchases</p>
      </div>

      <OrderHistory />

      {!isLoading && orders.length > 0 && (
        <div className="mt-6 text-sm text-gray-500">
          Having an issue with an order? Contact support via the WhatsApp number on your receipt.
        </div>
      )}

      {/* AI Chat Button */}
      <AIChatButton />
    </div>
  );
};

export default MyOrders;


